const formatPackageCustomizationForPrint = (customization) => {
  if (!customization) return "";

  try {
    const data =
      typeof customization === "string"
        ? JSON.parse(customization)
        : customization;

    if (!data || typeof data !== "object") return "";

    const isPackageCustomization =
      data.lineType === "PACKAGE" && Array.isArray(data.selectedGroups);

    if (!isPackageCustomization) return "";

    // =====================================================
    // SELECTED GROUPS
    // =====================================================
    const groupRows = (data.selectedGroups || [])
      .map((group) => {
        const groupItems = (group.items || [])
          .map((groupItem) => {
            if (!groupItem) return "";

            let quantityText = "";

            if (
              groupItem.quantityPerPerson !== null &&
              groupItem.quantityPerPerson !== undefined &&
              Number(groupItem.quantityPerPerson) > 0
            ) {
              quantityText = ` × ${groupItem.quantityPerPerson}/person`;
            } else if (
              groupItem.fixedQuantity !== null &&
              groupItem.fixedQuantity !== undefined &&
              Number(groupItem.fixedQuantity) > 0
            ) {
              quantityText = ` × ${groupItem.fixedQuantity}`;
            }

            const variantText = groupItem.variantName
              ? ` (${groupItem.variantName})`
              : "";

            const extraPrice =
              Number(groupItem.extraPrice || 0) > 0
                ? ` +Rs.${Number(groupItem.extraPrice).toFixed(2)}`
                : "";

            return `
              <span class="custom-item">
                ${groupItem.itemName || ""}
                ${variantText}
                ${quantityText}
                ${extraPrice}
              </span>
            `;
          })
          .filter(Boolean)
          .join(", ");

        if (!groupItems) return "";

        return `
          <tr class="package-detail-row">

            <td class="package-detail-spacer"></td>

            <td
              colspan="4"
              class="package-detail-cell"
            >
              <div class="custom-group">

                <div class="custom-group-title">
                  ${group.groupTitle || "Options"}
                </div>

                <div class="custom-group-items">
                  ${groupItems}
                </div>

              </div>
            </td>

          </tr>
        `;
      })
      .filter(Boolean)
      .join("");

    // =====================================================
    // ADDONS
    // =====================================================
    let addonsRow = "";

    if (Array.isArray(data.packageAddons) && data.packageAddons.length > 0) {
      const addons = data.packageAddons
        .map((addon) => {
          if (!addon) return "";

          const addonName =
            addon.itemName || addon.name || addon.addonName || "";

          if (!addonName) return "";

          let quantityText = "";

          if (
            addon.quantity !== null &&
            addon.quantity !== undefined &&
            Number(addon.quantity) > 0
          ) {
            quantityText = ` × ${addon.quantity}`;
          }

          let priceText = "";

          const addonPrice = addon.extraPrice ?? addon.price ?? addon.amount;

          if (
            addonPrice !== null &&
            addonPrice !== undefined &&
            Number(addonPrice) > 0
          ) {
            priceText = ` +Rs.${Number(addonPrice).toFixed(2)}`;
          }

          return `${addonName}${quantityText}${priceText}`;
        })
        .filter(Boolean)
        .join(", ");

      if (addons) {
        addonsRow = `
          <tr class="package-detail-row">

            <td class="package-detail-spacer"></td>

            <td
              colspan="4"
              class="package-detail-cell"
            >
              <div class="custom-group">

                <div class="custom-group-title">
                  Add-ons
                </div>

                <div class="custom-group-items">
                  ${addons}
                </div>

              </div>
            </td>

          </tr>
        `;
      }
    }

    // =====================================================
    // EVENT
    // =====================================================

    let eventRow = "";

    if (data.event && typeof data.event === "object") {
      const eventParts = [];

      if (data.event.location) {
        eventParts.push(data.event.location);
      }

      if (data.event.eventDate) {
        const dateParts = String(data.event.eventDate).split("-");

        if (dateParts.length === 3) {
          const [year, month, day] = dateParts;
          eventParts.push(`${day}/${month}/${year}`);
        } else {
          eventParts.push(data.event.eventDate);
        }
      }

      if (data.event.startTime) {
        eventParts.push(data.event.startTime);
      }

      if (data.event.endTime) {
        eventParts.push(`to ${data.event.endTime}`);
      }

      if (eventParts.length > 0) {
        eventRow = `
      <tr class="package-event-row">
        <td colspan="5" class="event-full-cell">

          <div class="header2 event-header">

            <div class="flex-row">

              <span class="textSizeMid">
                <b>Event:</b>
                ${eventParts.join(" • ")}
              </span>

            </div>

          </div>

        </td>
      </tr>
    `;
      }
    }

    return `
      ${groupRows}
      ${addonsRow}
      ${eventRow}
    `;
  } catch (error) {
    console.error("Package customization parse error:", error);

    return "";
  }
};

const PrintFull = (reciptDetails, item, fullAddress, userID) => {
  const receiptUserId = String(userID || "").trim();

  console.log("PRINT RECEIPT USER ID:", receiptUserId);
  // =====================================================
  // FALLBACK ADDRESS
  // =====================================================

  const rawAddress = String(fullAddress || "").trim();

  const isInvalidAddress =
    !rawAddress ||
    rawAddress === "-" ||
    rawAddress.toLowerCase() === "null" ||
    rawAddress.toLowerCase() === "undefined";

  const formattedAddress = (
    isInvalidAddress ? "Sector 63 Noida Noida" : rawAddress
  ).replace(/,/g, ",&nbsp;");

  // =====================================================
  // DELIVERY INFO
  // =====================================================

  const deliveryInfo =
    item.orderType === "home_delivery"
      ? `
        <p class="textSizeMid">
          Delivery Partner Name:
          ${item.delivery_person_name || "Not assigned"}
        </p>

        <p class="textSizeMid">
          Delivery Partner Mobile No.:
          ${item.delivery_person_number || "Not assigned"}
        </p>
      `
      : "";

  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    return;
  }

  const customerReceiptHTML = `
  <html>

    <head>

      <style>

        @page {
          size: auto;
          margin: 0;
        }

        * {
          box-sizing: border-box;
        }

        html,
        body {
          margin: 0;
          padding: 0;
        }

        body {
          width: 74mm;
          max-width: 74mm;
          margin: 0 auto;
          padding-top: 0;
          padding-bottom: 0;
          padding-left: 1mm;
          padding-right: 3mm;
          font-family: Arial, sans-serif;
          font-size: 16px;
          color: black;
        }


        /* =========================================
           HEADER
           ========================================= */

        .header {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          border-bottom: 1px dashed #000;
          line-height: 1.1;
          margin: 0;
          padding: 0;
        }

        .header2 {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          border-bottom: 1px dashed #000;
          line-height: 1.5;
          margin: 0;
          padding: 0;
        }

       .headerTable {
  width: 100%;
  border-bottom: none !important;
  margin: 0;
  padding: 0;
  overflow: visible;
}

        .headerTotal {
          width: 100%;
          display: flex;
          flex-direction: column;
          border-bottom: 1px dashed #000;
          padding: 0;
          margin: 0;
        }

        .headerEnd {
          width: 100%;
          text-align: center;
          margin: 0;
          padding: 0;
        }


        /* =========================================
           TOTAL AMOUNT ROWS
           ========================================= */

        .flex-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          margin: 1px 0;
          padding: 0;
        }

        .amount {
          min-width: 74px;
          flex-shrink: 0;
          text-align: right;

          padding-left: 2px;
          padding-right: 2mm;

          margin: 0;
          white-space: nowrap;
        }


        /* =========================================
           TEXT
           ========================================= */

        .textSizeLarge {
          font-size: 16px;
          margin: 1px;
        }

        .textSizeMid {
          font-size: 12px;
          margin: 0;
        }

        .textSizeSmall {
          font-size: 9px;
          margin: 1px;
        }


        /* =========================================
           TABLE
           ========================================= */

        table {
          width: 100%;
          max-width: 100%;
          border-collapse: collapse;
          border-spacing: 0;
          table-layout: fixed;
          margin: 0;
          padding: 0;
        }

        th,
        td {
          box-sizing: border-box;
          margin: 0;
          text-align: center;
          vertical-align: top;
        }

        th {
          font-size: 9px;
          font-weight: 700;
          white-space: nowrap;
          padding-top: 2px;
          padding-bottom: 2px;
        }

        td {
          font-size: 9px;
        }

        thead {
          display: table-row-group;
        }

        tfoot {
          display: table-row-group;
        }

        tr {
          page-break-inside: avoid;
        }


        /* =========================================
           COLUMNS
           ========================================= */

        .sr-column {
          width: 6%;
          vertical-align: top;
          text-align: center;
          font-size: 9px;
          padding: 2px 0;
        }

        .item-column,
        .package-item-column {
          width: 40%;
          text-align: left;
          vertical-align: top;
          word-break: break-word;
          overflow-wrap: anywhere;
          padding: 2px 1px;
        }

        /* Normal item name only */
        .normal-item-name {
          font-size: 10px;
          font-weight: 700;
          line-height: 1.15;
          text-align: left;
          word-break: break-word;
          overflow-wrap: anywhere;
        }

        .qty-column,
        .package-qty-column {
          width: 8%;
          vertical-align: top;
          text-align: center;
          font-size: 8px;
          padding: 2px 0;
        }

        .price-column,
        .package-price-column {
          width: 22%;
          vertical-align: top;
          text-align: right;
          font-size: 8px;
          white-space: nowrap;

          padding-top: 2px;
          padding-bottom: 2px;
          padding-left: 0;
          padding-right: 1mm;
        }

        .total-column,
        .package-total-column {
          width: 24%;
          vertical-align: top;
          text-align: right;
          font-size: 8px;
          white-space: nowrap;

          padding-top: 2px;
          padding-bottom: 2px;
          padding-left: 0;
          padding-right: 2mm;
        }


        /* =========================================
           TABLE HEADERS
           ========================================= */

        th.qty-column {
          text-align: center;
          font-size: 9px;
          padding-left: 0;
          padding-right: 0;
        }

        th.price-column {
          text-align: right;
          font-size: 9px;
          white-space: nowrap;
          padding-left: 0;
          padding-right: 1mm;
        }

        th.total-column {
          text-align: right;
          font-size: 9px;
          white-space: nowrap;
          padding-left: 0;
          padding-right: 2mm;
        }


        /* =========================================
           BASIC PACKAGE
           ========================================= */

        .package-main-row td {
          padding-top: 1px;
          padding-bottom: 0;
        }

        .package-item-name {
          font-size: 11px;
          font-weight: 700;
          line-height: 1.1;

          margin: 0;
          padding: 0;

          text-align: left;
          word-break: break-word;
        }


        /* =========================================
           11 PERSONS
           ========================================= */

        .package-summary-row {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .package-summary-spacer {
  width: 6%;
  margin: 0;
  padding: 0;
  border-bottom: 1px dashed #000;
}

.package-summary-cell {
  text-align: left;
  margin: 0;
  padding-top: 0;
  padding-bottom: 1px;
  padding-left: 1px;
  padding-right: 0;
  border-bottom: 1px dashed #000;
}

        .package-summary {
          font-size: 7px;
          font-weight: 600;
          line-height: 1.05;

          margin: 0;
          padding: 0;

          border: none;
        }


        /* =========================================
           PACKAGE DETAIL ROWS
           ========================================= */

        .package-detail-row,
        .package-event-row {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .package-detail-spacer {
          width: 6%;
          margin: 0;
          padding: 0;
        }

        .package-detail-cell {
          text-align: left;
          vertical-align: top;

          margin: 0;

          padding-left: 1px;
          padding-right: 2mm;

          /*
            IMPORTANT:
            bottom spacing nahi diya.
            Next row top spacing handle karega.
          */
          padding-bottom: 0;
        }


        /* =========================================
           SPACE AFTER 11 PERSONS

           Main Course ko sirf TOP spacing.
           11 Persons ko bottom margin nahi.
           ========================================= */

        .package-summary-row +
        .package-detail-row
        .package-detail-cell {
          padding-top: 3px;
        }


        /* =========================================
           MAIN COURSE / BREADS / SIDES
           ========================================= */

        .custom-group {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .custom-group-title {
          width: 100%;

          font-size: 11px;
          font-weight: 700;
          line-height: 1.05;

          /*
            Bottom space nahi.
            Item ko top space diya hai.
          */
          margin: 0;
          padding: 0;

          text-align: left;
        }


        /* =========================================
           RELATED ITEMS

           Dal Makhani
           Tawa Butter Roti
           Sides items
           ========================================= */

        .custom-group-items {
          width: 100%;

          font-size: 9px;
          font-weight: normal;
          line-height: 1.1;

          /*
            Title ke baad only TOP space.
          */
          margin: 2px 0 0 0;

          padding: 0;

          text-align: left;

          word-break: normal;
          overflow-wrap: break-word;
        }

        .custom-item {
          display: inline;
        }

        /* =========================================
           EVENT
           ========================================= */

        .package-detail-row +
        .package-event-row
        .package-detail-cell {
          padding-top: 3px;
        }

        .event-full-cell {
  width: 100%;
  padding: 0;
  margin: 0;
  text-align: left;
}

.event-header {
  border-top: 1px dashed #000;
}

        /* =========================================
   EVENT - FULL ROW BORDER
   Same as Main Course top separator
   ========================================= */

.event-spacer {
  padding-top: 0;
  padding-bottom: 0;
}

.custom-event {
  width: 100%;

  font-size: 11px;
  font-weight: 700;
  line-height: 1.05;

  margin: 0;

  padding-top: 3px;
  padding-bottom: 3px;

  text-align: left;

  border: none;

  word-break: normal;
  overflow-wrap: break-word;
}

        /* =========================================
           NO EXTRA SPACE AFTER EVENT
           ========================================= */

        .package-event-row td {
          padding-bottom: 0;
          margin-bottom: 0;
        }

        .headerTable table {
          margin-bottom: 0;
          padding-bottom: 0;
        }

        .headerTable + .headerTotal {
          margin-top: 0;
        }

        .headerTotal .flex-row:first-child {
          margin-top: 0;
        }


        /* =========================================
           PAID AMOUNT
           ========================================= */

        .header2 .flex-row {
          padding-right: 0;
        }

      </style>

    </head>


    <body>


      <!-- =========================================
           HEADER
           ========================================= -->

      <div class="header">

        <p class="textSizeLarge">
          <b>
            ${reciptDetails.business_name || ""}
          </b>
        </p>

        <p class="textSizeMid">
          ${reciptDetails.address || ""}
        </p>

        <p class="textSizeMid">
          PH:
          ${reciptDetails.phone_no || ""}
        </p>

<p class="textSizeMid">
  GST NO:
  ${reciptDetails.gst || ""}
</p>

${
  receiptUserId === "A1222"
    ? `
      <p class="textSizeMid">
        FSSAI NO:
        12724052000539
      </p>
    `
    : ""
}

        <p class="textSizeLarge">
          <b>
            ** INVOICE **
          </b>
        </p>

      </div>


      <!-- =========================================
           ORDER DETAILS
           ========================================= -->

      <div class="header2">

        <p class="textSizeMid">
          Order No:
          ${item.daily_order_id || ""}
          /
          ${item.orderid || ""}
        </p>

        <p class="textSizeMid">
          Order Type:
          ${item.orderType || ""}
        </p>

        <p class="textSizeMid">
          Customer Name:
          ${item.customer_name || ""}
        </p>

        <p class="textSizeMid">
          Customer Mobile:
          ${item.customer_mobile || ""}
        </p>

        <p class="textSizeMid">
          Payment Status:
          ${item.payment_status || ""}
        </p>

        <p class="textSizeMid">
          Payment Mode:
          ${item.payment_mode || ""}
        </p>

        <p class="textSizeMid">
          Order Date:
          ${item.order_date || ""}
        </p>

        ${deliveryInfo}

        ${
          item.orderType === "home_delivery"
            ? `
              <p class="textSizeMid">
                Delivery Address:
                ${formattedAddress || "-"}
              </p>
            `
            : ""
        }

        ${
          item.orderType === "dining"
            ? `
              <p class="textSizeMid">
                Table No:
                ${item.table_no || ""}
              </p>
            `
            : ""
        }

        ${
          item.orderType === "car_order"
            ? `
              <p class="textSizeMid">
                Vehicle No.:
                ${item.table_no || ""}
              </p>
            `
            : ""
        }

        ${
          item.orderType === "office_order"
            ? `
              <p class="textSizeMid">
                Office No.:
                ${item.table_no || ""}
              </p>
            `
            : ""
        }

      </div>


      <!-- =========================================
           ITEMS
           ========================================= -->

      <div class="headerTable">

        <table>

          <thead>

            <tr>

              <th class="sr-column">
                Sr
              </th>

              <th class="item-column">
                Item
              </th>

              <th class="qty-column">
                Qty
              </th>

              <th class="price-column">
                Price
              </th>

              <th class="total-column">
                Total
              </th>

            </tr>

          </thead>


          <tbody>

            ${
              item.items
                ?.map((subitem, index) => {
                  let customization = null;

                  try {
                    customization =
                      subitem.customization && subitem.customization !== "{}"
                        ? typeof subitem.customization === "string"
                          ? JSON.parse(subitem.customization)
                          : subitem.customization
                        : null;
                  } catch (error) {
                    customization = null;
                  }

                  // =====================================
                  // PACKAGE CHECK
                  // =====================================

                  const isPackageCustomization =
                    customization?.lineType === "PACKAGE" &&
                    Array.isArray(customization?.selectedGroups);

                  // =====================================
                  // PACKAGE
                  // =====================================

                  if (isPackageCustomization) {
                    const customizationHTML =
                      formatPackageCustomizationForPrint(customization);

                    const packageName =
                      customization.packageName ||
                      subitem.item_name ||
                      subitem.product_id ||
                      "Package";

                    // =====================================
                    // PERSON / VARIANT SUMMARY
                    // =====================================

                    const summaryParts = [];

                    if (customization.variantName) {
                      summaryParts.push(customization.variantName);
                    }

                    if (
                      customization.people &&
                      !String(customization.variantName || "")
                        .toLowerCase()
                        .includes(String(customization.people))
                    ) {
                      summaryParts.push(`${customization.people} Persons`);
                    }

                    const packageSummary = summaryParts.join(" • ");

                    return `

                        <!-- =========================
                             BASIC PACKAGE ROW
                             ========================= -->

                        <tr class="package-main-row">

                          <td class="sr-column">
                            ${index + 1}
                          </td>


                          <td class="package-item-column">

                            <div class="package-item-name">
                              ${packageName}
                            </div>

                          </td>


                          <td class="package-qty-column">
                            ${subitem.quantity || 0}
                          </td>


                          <td class="package-price-column">
                            ${Number(subitem.item_price || 0).toFixed(2)}
                          </td>


                          <td class="package-total-column">
                            ${Number(subitem.total_price || 0).toFixed(2)}
                          </td>

                        </tr>


                        <!-- =========================
                             PERSONS FULL LINE
                             ========================= -->

                        ${
                          packageSummary
                            ? `
                              <tr class="package-summary-row">

                                <td class="package-summary-spacer">
                                </td>


                                <td
                                  colspan="4"
                                  class="package-summary-cell"
                                >

                                  <div class="package-summary">
                                    ${packageSummary}
                                  </div>

                                </td>

                              </tr>
                            `
                            : ""
                        }


                        <!-- =========================
                             MAIN COURSE / BREAD /
                             SIDES / EVENT
                             ========================= -->

                        ${customizationHTML}

                      `;
                  }

                  // =====================================
                  // NORMAL CUSTOMIZATION
                  // OLD LOGIC - SAME
                  // =====================================

                  let customizationText = "";

                  if (customization) {
                    const parts = Object.values(customization);

                    customizationText =
                      parts.length > 0
                        ? `
                            <div>
                              (${parts.join(" | ")})
                            </div>
                          `
                        : "";
                  }

                  return `

                      <tr>

                        <td class="sr-column">
                          ${index + 1}
                        </td>


                        <td class="item-column">
                          <div class="normal-item-name">
                            ${subitem.product_id || ""}
                          </div>

                          ${customizationText}
                        </td>


                        <td class="qty-column">
                          ${subitem.quantity || 0}
                        </td>


                        <td class="price-column">
                          ${Number(subitem.item_price || 0).toFixed(2)}
                        </td>


                        <td class="total-column">
                          ${Number(subitem.total_price || 0).toFixed(2)}
                        </td>

                      </tr>

                    `;
                })
                .join("") || ""
            }

          </tbody>

        </table>

      </div>


      <!-- =========================================
           TOTAL
           ========================================= -->

      <div class="headerTotal">

        <div class="flex-row">

          <span class="textSizeMid">
            Sub Total :
          </span>

          <span class="textSizeMid amount">
            Rs.
            ${Number(item.subtotal || 0).toFixed(2)}
          </span>

        </div>


        ${
          item.gst_claim === "Y"
            ? `

              <div class="flex-row">

                <span class="textSizeMid">
                  CGST (2.5%) :
                </span>

                <span class="textSizeMid amount">
                  Rs.
                  ${Number(item.tax_cgst || 0).toFixed(2)}
                </span>

              </div>


              <div class="flex-row">

                <span class="textSizeMid">
                  SGST (2.5%) :
                </span>

                <span class="textSizeMid amount">
                  Rs.
                  ${Number(item.tax_sgst || 0).toFixed(2)}
                </span>

              </div>

            `
            : ""
        }


        <div class="flex-row">

          <span class="textSizeMid">
            Delivery Fee :
          </span>

          <span class="textSizeMid amount">
            Rs.
            ${Number(item.delivery_fee || 0).toFixed(2)}
          </span>

        </div>


        <div class="flex-row">

          <span class="textSizeMid">
            Other Fee :
          </span>

          <span class="textSizeMid amount">
            Rs.
            ${Number(item.other_fee || 0).toFixed(2)}
          </span>

        </div>


        <div
          class="flex-row"
          style="font-weight: 600;"
        >

          <span class="textSizeMid">
            Total Amount :
          </span>

          <span class="textSizeMid amount">
            Rs.
            ${Number(item.pay_amount || 0).toFixed(2)}
          </span>

        </div>

      </div>


      <!-- =========================================
           PAID AMOUNT
           ========================================= -->

      <div class="header2">

        <div class="flex-row">

          <span class="textSizeMid">
            Paid Amount :
          </span>

          <span class="textSizeMid amount">
            Rs.
            ${Number(item.pay_amount || 0).toFixed(2)}
          </span>

        </div>

      </div>


      <!-- =========================================
           FOOTER
           ========================================= -->

      <div class="headerEnd">

        <p class="textSizeMid">
          Thank you for your purchase!
        </p>

        <p class="textSizeSmall">
          * Order Managed By Chaafo*
        </p>

      </div>

    </body>

  </html>
  `;

  printWindow.document.write(customerReceiptHTML);

  printWindow.document.close();

  printWindow.focus();

  printWindow.print();

  printWindow.close();
};

export default PrintFull;
